<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showPackage") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #f7941e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.packageName')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Duration Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_duration')"
            v-model.trim="data.duration_in_days"
            disabled
          />
          <!-- End:: Duration Input -->

          <!-- Start:: Price Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_price')"
            v-model.trim="data.price"
            disabled
          />
          <!-- End:: Price Input -->

          <!-- Start:: Users Count Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.users_count')"
            v-model.trim="data.users_count"
            disabled
          />
          <!-- End:: Users Count Input -->

          <!-- Start:: Activation Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.activation
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.activation"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Activation Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowPackage",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name: null,
        duration_in_days: null,
        price: null,
        users_count: null,
        activation: 1,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // start show data
    async showPackage() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `packages/${this.$route.params?.id}`,
        });
        const packageData = res.data.data.Package;
        this.data.name = packageData.name;
        this.data.duration_in_days = packageData.duration_in_days;
        this.data.price = packageData.price;
        this.data.users_count = packageData.users_count;
        this.data.activation = packageData.activation;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },

  created() {
    this.showPackage();
  },
};
</script>
